import { useEffect, useRef } from 'react';
import { colors } from 'styles/theme/colors';
import { CheckboxProps, StyledCheckbox } from './Checkbox';

export const IndeterminateCheckbox = ({
  indeterminate,
  'aria-label': ariaLabel,
  ...rest
}: CheckboxProps & { indeterminate?: boolean }) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!ref?.current) return;
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <StyledCheckbox
      sx={{
        '&.Mui-checked': {
          color: colors.brand[400],
        },
        '&.MuiCheckbox-indeterminate': {
          color: colors.brand[400],
        },
      }}
      indeterminate={indeterminate}
      {...rest}
      // Route an accessible name onto the real <input> (the ref pins indeterminate state). A
      // top-level aria-label would land on the wrapper span, leaving the control unnamed for SRs.
      slotProps={{ input: { ref, 'aria-label': ariaLabel } }}
    />
  );
};
